import {Component} from '@angular/core';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerEvents,
  DatatableHandlerSettings,
  IconType,
} from '../datatable/datatable/datatable.component';
import {ActivatedRoute, Router} from '@angular/router';
import {StudentExamDataService} from '../../../services/data-services/student-exam-data.service';
import {
  DataTableDataService,
  SimpleNavigationPathDataService,
} from '../../../services/data-services/navigation-data-services';
import {ExamReportDataService} from 'src/app/services/data-services/exam-report-data.service';
import {DataTableRoutes} from 'src/app/constants/datatableUrls';
import {ToastrService} from 'ngx-toastr';
import {ConfirmModalComponent} from '../../modals/confirm-modal/confirm-modal.component';
import {SimpleModalService} from 'ngx-simple-modal';
import {ExamReportsClient, StudentsClient} from '../../../generated-client/generated-api-client';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {StudentImportModalComponent} from '../../modals/student-import-modal/student-import-modal.component';
import { PersistentDataService } from '../../../services/persistent-data.service';
import { SyncDataService } from 'src/app/services/data-services/sync-data.service';

@Component({
  selector: 'app-students-datatable',
  templateUrl: './students-datatable.component.html',
  styleUrls: ['./students-datatable.component.sass'],
})
export class StudentsDatatableComponent {
  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtEvents: DatatableHandlerEvents = DatatableHandler.getDefaultEvents();
  dtDataSourceUrl: string = DataTableRoutes.StudentList;

  examReportId: string = '';
  // examReportStatus?: ExamReportStatus;
  isModifiable!: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _studentExamDataService: StudentExamDataService,
    private _navigationService: SimpleNavigationPathDataService,
    private _dataTableService: DataTableDataService,
    private _toastr: ToastrService,
    private _modalService: SimpleModalService,
    private _errorProcessorService: ErrorProcessorService,
    private studentsClient: StudentsClient,
    private examReportClient: ExamReportsClient,
    private _examReportDateService: ExamReportDataService,
    private _syncDataService: SyncDataService,
    private _pDservice: PersistentDataService
  ) {
    route.parent?.paramMap?.subscribe(params => {
      this.examReportId = params.get('id') ?? '';
    });
    this.navigateTo = router.url;
    this.navigateBack = router.url;
    this.dtSettings.actions = this._dtActionButtonsFn;
    this.dtSettings.pageSize = _pDservice.examReportsPageSize;
    this.dtSettings.searchString = _pDservice.examReportsSearchString;
    this.dtDataSourceUrl = `${DataTableRoutes.StudentList}?ExamReportId=${this.examReportId}`;

    this.dtEvents.selectedRow = (row, data) => {
      this.studentName = data['fullName'];
      this.registrationNumber = data['registrationNumber'];
      this._studentExamDataService.canLoad.next(true);

      this.router.navigate([`${row.id}`], {
        relativeTo: this.route,
      });
    };

    this.dtEvents.unselectedRow = () => {
      const url = this.router.url.split('/');
      this.router.navigate(['..', url[url.length - 2]], {
        relativeTo: this.route,
      });
    };

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.examReportsPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.examReportsSearchString = this.dtHandler?.searchString
      return {

      };
    };
  }


  set navigateTo(value: string) {
    this._navigationService.navigateToPath = value;
  }

  set navigateBack(value: string) {
    this._navigationService.navigateBackPath = value;
  }

  set dataTableToService(dtHandler: DatatableHandler) {
    this._dataTableService.dataTable = dtHandler;
  }

  set registrationNumber(value: string) {
    this._studentExamDataService.registrationNumber.next(value);
  }

  set studentName(value: string) {
    this._studentExamDataService.studentName.next(value);
  }

  onDtInit(dtHandler: DatatableHandler) {
    this.dtHandler = dtHandler;
    this.dataTableToService = dtHandler;

    this.examReportClient.isModifiable(this.examReportId).subscribe(isModifiable => {
      this.isModifiable = isModifiable;
      this._examReportDateService.isModifiable.next(isModifiable);
      if (this.route.firstChild) {
        this.route.firstChild.paramMap.subscribe(next => {
          const studentId = next.get('id');
          if (studentId) {
            this.dtEvents.initComplete = () => {
              const row = this.dtHandler?.getRowById(studentId);
              row?.querySelector('td')?.click();
            };
          }

          this.setSpecificDtSettings(this.isModifiable);
          this.dtHandler?.create();
        });
      } else {
        this.setSpecificDtSettings(this.isModifiable);
        this.dtHandler?.create();
      }
    });

  }

  onAction(event: DatatableEvent) {
    if (event.actionId === 'student_delete') {
      if (!this.isModifiable) {
        this._toastr.error('A jegyzőkönyv már nem módosítató.');
      } else {
        this.delete(event.data['id']);
      }
    }
  }

  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const id = data['id'];

    const editUrl = `/students/${id}/exam-report/${this.examReportId}`;
    const editAction =
      this.isModifiable
        ? new DatatableActionButton('edit', 'Vizsgázó szerkesztése', 'edit', editUrl)
        : new DatatableActionButton('edit', 'Vizsgázó szerkesztése', 'edit', editUrl, IconType.Normal, true);

    const deleteAction = new DatatableActionButton(
      'student_delete',
      'Vizsgázó törlése',
      'delete',
      undefined,
      IconType.Danger,
      !this.isModifiable
    );

    return [editAction, deleteAction];
  };

  private delete(id: string): void {
    this._modalService
      .addModal(ConfirmModalComponent, {
        title: 'Vizsgázó törlése',
        message: 'Biztosan törli a vizsgázót?',
        confirmText: 'Törlés',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.studentsClient.delete(id).subscribe(
            next => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres törlés');
            },
            error => this._errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private setSpecificDtSettings(isModifiable: boolean): void {
    if (isModifiable) {
      this.dtSettings.buttons = [
        {
          text: 'Új vizsgázó',
          class: 'btn-primary text-white',
          url: `students/new/exam-report/${this.examReportId}`,
        },
        {
          text: 'Importálás',
          class: 'btn-primary text-white',
          action: () => {
            this._modalService
              .addModal(StudentImportModalComponent, { examReportId: this.examReportId })
              .subscribe(result => {
                if (result) {
                  this.dtHandler?.refresh();
                  this._syncDataService.afterSuccessfulOperation.next();
                }
              });
          },
        },
      ];
    } else {
      this.dtSettings.additionalColumns = [
        {
          targets: 10,
          orderable: false,
          visible: false,
        },
      ];
    }
  }
}
